module.exports = __webpack_public_path__ + "img/40.b6c1cf75.jpg";